var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharedTemplateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F6F5F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2014_36081",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2014_36081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 22C20.55 22 21.0208 21.8042 21.4125 21.4125C21.8042 21.0208 22 20.55 22 20C22 19.45 21.8042 18.9792 21.4125 18.5875C21.0208 18.1958 20.55 18 20 18C19.45 18 18.9792 18.1958 18.5875 18.5875C18.1958 18.9792 18 19.45 18 20C18 20.55 18.1958 21.0208 18.5875 21.4125C18.9792 21.8042 19.45 22 20 22ZM16 26H24V25.425C24 25.025 23.8917 24.6583 23.675 24.325C23.4583 23.9917 23.1583 23.7417 22.775 23.575C22.3417 23.3917 21.8958 23.25 21.4375 23.15C20.9792 23.05 20.5 23 20 23C19.5 23 19.0208 23.05 18.5625 23.15C18.1042 23.25 17.6583 23.3917 17.225 23.575C16.8417 23.7417 16.5417 23.9917 16.325 24.325C16.1083 24.6583 16 25.025 16 25.425V26ZM26 30H14C13.45 30 12.9792 29.8042 12.5875 29.4125C12.1958 29.0208 12 28.55 12 28V12C12 11.45 12.1958 10.9792 12.5875 10.5875C12.9792 10.1958 13.45 10 14 10H22L28 16V28C28 28.55 27.8042 29.0208 27.4125 29.4125C27.0208 29.8042 26.55 30 26 30ZM26 28V16.85L21.15 12H14V28H26Z",
    fill: "#009B77"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharedTemplateIcon);
export default __webpack_public_path__ + "static/media/sharedTemplateIcon.b33e7e43b707e74acc4e7782433cdeda.svg";
export { ForwardRef as ReactComponent };